import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import DotIcon from '../../../../components/DotIcon';
import { LinearProgress } from '@mui/material';
import {
    calculateContentStatusPercentage,
    getZitoneoPresentationQualityLevel,
} from '../../../utils/zitoneoContentScoreUtils';

interface StatusItem {
    label: string;
    value: number;
    maxValue: number;
}

interface ContentStatusSectionProps {
    title: string;
    statusItems: StatusItem[];
}

const ContentStatusSection = ({
    title,
    statusItems,
}: ContentStatusSectionProps) => {
    const translate = useTranslate();
    const sectionProgress = calculateContentStatusPercentage(statusItems);
    const sectionProgressQuality =
        getZitoneoPresentationQualityLevel(sectionProgress);

    return (
        <section className='content-status__section'>
            <div className='content-status-section__header'>
                <div className='category-item__title-wrapper'>
                    <h5 className='content-status-section__header-title'>
                        {translate(title)}
                    </h5>
                    <p
                        style={{ color: sectionProgressQuality.color }}
                        className='content-status-section__header-progress'
                    >
                        {sectionProgress.toFixed(0)}%
                    </p>
                </div>
                <div className='category-item__progress'>
                    <LinearProgress
                        variant='determinate'
                        value={sectionProgress}
                        sx={{
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: sectionProgressQuality.color,
                            },
                        }}
                    />
                </div>
            </div>

            <ul className='content-status__list'>
                {statusItems.map((item, index) => {
                    const percentage =
                        item.maxValue > 0
                            ? (item.value / item.maxValue) * 100
                            : 0;
                    const qualityLevel =
                        getZitoneoPresentationQualityLevel(percentage);
                    return (
                        <li
                            key={index}
                            className='content-status-section__item'
                        >
                            <div className='content-status-section__item-label-wrapper'>
                                <DotIcon
                                    restStyles={{
                                        color: qualityLevel.color,
                                    }}
                                />
                                <p className='content-status-section__item-label'>
                                    {translate(item.label)}
                                </p>
                            </div>
                            <p className='content-status-section__item-value'>
                                {item.value} / {item.maxValue}
                            </p>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export default ContentStatusSection;
